<template>
    <div>
        <CompanyUserSearch v-bind:queryParams="queryParams"
                           v-bind:fullDate="fullDate" />

        <CompanyUserList  v-bind:queryParams="queryParams"
                           v-bind:fullDate="fullDate" />
    </div>
</template>
<script>
import CompanyUserSearch from './component/CompanyUserSearch';
import CompanyUserList from './component/CompanyUserList'
const moment = require("moment");
export default {
    name: "companyUserManagementList",
    components: {
        CompanyUserSearch,
        CompanyUserList,
    },
    data() {
        return {
            fullDate: [],
            queryParams: {
                keyword: '',
                pTypeSearchArr: [],         // 사용자구분
                periodTypeSearchArr: [],    // 상품기간
                downloadTypeSearchArr: [], // 다운로드 타입
                authStateTypeSearchArr: [], // 권한 상태
            },
        }
    },
    methods: {
        getFormatDate(date) {
            if (!date) return;
            return moment(date).format("YYYY-MM-DD");
        },
    }
}
</script>
<style scoped>
  .mx-datepicker{
    width : 100% !important;
  }

  table tr th, td {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/views/user/companyUserList/CompanyUserManagementList.vue